export default __webpack_public_path__ + "static/media/strategyImg0.23ddb63c.jpg";